/**
 * TEMP FIX — Homepage hero buttons (PageFly)
 *
 * The homepage hero buttons are generated by PageFly (sections/pagefly-home.liquid),
 * which is auto-regenerated any time that page is edited/republished in the
 * PageFly editor. That means we can't safely fix their behavior by editing the
 * PageFly-generated Liquid directly — it would get overwritten.
 *
 * This script finds both hero buttons at runtime and fixes them:
 *
 * 1. "Sign In & Shop" button (PageFly has republished this with a couple of
 *    different broken hrefs already: https://kennicott.com/account, then
 *    https://kennicott.com/login, the latter a 404 since it isn't a real
 *    Shopify route)
 *    - Signed out: routes through sign-in and returns to SHOP_URL afterwards,
 *      instead of landing on the account/orders page.
 *    - Signed in: links straight to SHOP_URL and swaps the label to
 *      "Shop Fresh", skipping the sign-in step entirely.
 *
 * 2. "Join Kennicott" button (currently links to /pages/join-kennicott)
 *    - Signed out: left as-is (still invites them to join).
 *    - Signed in: since they've already joined, this becomes a "Shop Supplies"
 *      link instead, pointing to the supplies collection.
 *
 * Remove this file (and its <script> include in theme.liquid) once the
 * Hydrogen storefront replaces this PageFly homepage.
 */
(function () {
  // NOTE: these must be relative paths, not absolute URLs. Shopify's
  // /customer_authentication/login only honors return_to for relative URLs —
  // an absolute URL here causes the redirect to misbehave (it stops actually
  // routing through the sign-in flow).
  var SIGN_IN_SHOP_URL = '/pages/flowers-plants';
  var SUPPLIES_URL = '/collections/supplies';

  // PageFly has changed this href across republishes (seen: /account, then
  // /login — the latter isn't even a valid Shopify route and 404s on its
  // own). Matching on href alone is fragile, so we match on a known-href
  // allowlist AND fall back to matching by the button's visible label,
  // since PageFly is far less likely to change the text than the href.
  var SIGN_IN_BUTTON_HREFS = ['https://kennicott.com/account', 'https://kennicott.com/login'];
  var JOIN_BUTTON_HREF = '/pages/join-kennicott';

  var SIGNED_OUT_TEXT = 'Sign In & Shop';
  var SIGNED_IN_SHOP_TEXT = 'Shop Fresh';
  var SIGNED_IN_SUPPLIES_TEXT = 'Shop Supplies';

  function findSignInButtons() {
    var hrefSelector = SIGN_IN_BUTTON_HREFS.map(function (href) {
      return 'a[href="' + href + '"]';
    }).join(', ');
    var matches = document.querySelectorAll(hrefSelector);

    if (matches.length === 0) {
      // Fallback: match by visible label, in case PageFly republished with
      // yet another href we haven't seen before.
      matches = Array.prototype.filter.call(document.querySelectorAll('a'), function (/** @type {HTMLAnchorElement} */ a) {
        return a.textContent.trim() === SIGNED_OUT_TEXT;
      });
    }

    return matches;
  }

  function fixButtons() {
    var signInButtons = findSignInButtons();
    // Scope to #__pf (the PageFly root) so we only rewrite the homepage hero
    // button and never affect nav/menu links with the same href on other parts
    // of the page.
    var pfRoot = document.getElementById('__pf');
    var joinButtons = pfRoot
      ? pfRoot.querySelectorAll('a[href="' + JOIN_BUTTON_HREF + '"]')
      : document.querySelectorAll('a[href="' + JOIN_BUTTON_HREF + '"]');
    var signedIn = Boolean(window.__kennicottCustomerSignedIn);

    signInButtons.forEach(function (button) {
      if (signedIn) {
        button.setAttribute('href', SIGN_IN_SHOP_URL);
        button.textContent = SIGNED_IN_SHOP_TEXT;
      } else {
        button.setAttribute('href', '/customer_authentication/login?return_to=' + encodeURIComponent(SIGN_IN_SHOP_URL));
        button.textContent = SIGNED_OUT_TEXT;
      }
    });

    if (signedIn) {
      joinButtons.forEach(function (button) {
        button.setAttribute('href', SUPPLIES_URL);
        button.textContent = SIGNED_IN_SUPPLIES_TEXT;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixButtons);
  } else {
    fixButtons();
  }
})();
